export default __webpack_public_path__ + "static/media/fullscreen.4b50999b.png";